document.addEventListener('click', event => {
  const triggerElement = event.target.closest('[data-modal-trigger]');
  if (triggerElement) {
    const modalId = triggerElement.getAttribute('data-modal-id');
    if (modalId) {
      event.preventDefault();
      event.stopPropagation();
      if (modalId === 'pacmangametest') {
        window.dispatchEvent(new CustomEvent('pacman:open', {
          detail: { modalId }
        }));
        return;
      }
      window.activeModalID = modalId;
      if (typeof window.showModal === 'function') {
        window.showModal(undefined, {
          modalId,
          source: 'manual'
        });
      }
    } else {
      console.error('No data-modal-id found on the clicked element.');
    }
  }
});
